module.exports = __webpack_public_path__ + "img/bjinfo.91fccb77.png";